import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */

export const { Types, Creators } = createActions({
  hideModal: [],
  requestRetrieveTicketRatings: [],
  successRetrieveTicketRatings: []
});

/* Reducer handlers */

const INITIAL_STATE = Immutable({
  visible: false,
  ratings: [],
});

const hideModal = (state = INITIAL_STATE) =>
  ({ ...state, visible: false });

const successRetrieveTicketRatings = (state = INITIAL_STATE, action) =>
  ({ ...state, ratings: action.payload, visible: true });

export default createReducer(INITIAL_STATE, {
  [Types.SUCCESS_RETRIEVE_TICKET_RATINGS]: successRetrieveTicketRatings,
  [Types.HIDE_MODAL]: hideModal,
});
